import { r2Fetch } from './client';
import { R2FileGetResponse } from '../types';

export interface R2FileGetParams {
  bucket_id: string;
  key: string;
}

export async function r2FileGet(
  params: R2FileGetParams
): Promise<R2FileGetResponse> {
  return r2Fetch<R2FileGetResponse>('/rpc/r2_file_get', {
    body: params,
  });
}
